import { ENTRYPOINTS } from 'ai/constants/superchat';

function findPreviousSession(conversationResponse, entryPointData) {
    if (!conversationResponse || !entryPointData) {
        return null;
    }

    const lastMessage = conversationResponse.messages?.at();
    const lastSession = conversationResponse.sessions?.find(s => s.session_id === lastMessage?.session_id);

    if (lastSession && lastSession.expired) {
        // New session needed
        return null;
    }

    if (lastSession?.entrypoint === ENTRYPOINTS.PDP) {
        if (lastSession.products?.[0]?.id === entryPointData.products?.[0]?.product_id) {
            return lastSession.session_id;
        }
    } else if (lastSession?.entrypoint === ENTRYPOINTS.PLP) {
        if (lastSession.category_id === entryPointData.category_id) {
            return lastSession.session_id;
        }
    }

    return null;
}

export default findPreviousSession;
